import React, { useEffect, useState } from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import './App.css';
import { CalcCe } from './components/pages/CalcCe';
import { CalcAProof } from './components/pages/CalcAProof';
import { Login } from './components/pages/Login';
import { NavigationHeader } from './components/parts/NavigationHeader';
import { UserContextProvider } from './contexts/UserContext';
import { BackendService } from './backend/BackendService';
import { NavigationFooter } from './components/parts/NavigationFooter';

function App() {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    console.log("App-useEffect");
    BackendService.refreshCsrfToken()
      .finally(() => setInitialized(true));
  }, []);

  if (!initialized) {
    return (
      <React.Fragment />
    );
  }
  
  return (
    <UserContextProvider>
      <BrowserRouter>
        <NavigationHeader />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/calcce" element={<CalcCe/ >} />
          <Route path="/calcap" element={<CalcAProof/ >} />
        </Routes>
        <NavigationFooter />
      </BrowserRouter>
    </UserContextProvider>
  );
}

export default App;
